const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the assignment content component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignmentContent', ['AdminContent', function(AdminContent) {
  return {
    restrict: 'E',
    scope: {
      content: '='
    },
    template: require('../../../templates/directives/assignments/assignment-content.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.table = {
        page_request: 1,
        per_page_request: 8,
        page: 0,
        per_page: 15,
        queue: [],
        page_store: {},
        out_of_content: false,
        next: function() {
          if (this.page_store[this.page + 1]) {
            this.page++;
            self.information.activeContent = this.page_store[this.page];
            return;
          }

          if (this.queue.length && this.queue.length >= this.per_page) {
            this.page_store[this.page + 1] = this.queue.splice(0, this.per_page);
            this.page++;
            self.information.activeContent = this.page_store[this.page];
            return;
          }

          if (this.out_of_content && this.queue.length) {
            this.page_store[this.page + 1] = this.queue.splice(0);
            this.page++;
            self.information.activeContent = this.page_store[this.page];
            return;
          }

          if (this.out_of_content) {
            return;
          }

          this.refill_queue()
          .then(function() {
            self.table.next();
          }).catch(function(error) {
            console.log('error in refill_queue: ', error);
          });
        },
        previous: function() {
          if (this.page > 1) {
            this.page--;
            self.information.activeContent = this.page_store[this.page];
          }
        },
        refill_queue: function() {
          return AdminContent.findAnalytics({
            types: 'videos,files,articles,scorm,assessments,tracks,imported_content,workshops,journeys',
            page: self.table.page_request,
            per_page: self.table.per_page_request,
            archived: '$ne,true',
            sort: 'createdAt,-1',
            published_only: true,
            manager_priority: true
          }).$promise.then(function(results) {
            self.table.page_request++;
            if (!results.next_exists) {
              self.table.out_of_content = true;
            }

            if (results.data && results.data.length) {
              self.table.queue = [].concat(self.table.queue, results.data);

              self.table.queue.sort(function(a, b) {
                if (a.createdAt < b.createdAt) {
                  return 1;
                }
                if (a.createdAt > b.createdAt) {
                  return -1;
                }
                return 0;
              });
            }
            return;
          });
        },
        nextAvailable: function() {
          return !self.table.out_of_content || self.table.page_store[self.table.page + 1];
        }
      };

      self.information = {
        loading: false,
        type: 'content',
        simple_selection: [],
        selection: [],
        activeContent: [],
        directory: {},
        searching: false,
        searchPage: 1,
        searchPlaceholder: 'assignContent.searchContent_placeholder',
        clearFilter: false,
        searchQuery: {},
        types: ['videos', 'files', 'articles', 'scorm', 'assessments', 'tracks', 'imported_content', 'workshops', 'journeys'],
        onQuery: async function(opts) {
          self.information.searchQuery = {
            types: 'videos,files,articles,scorm,assessments,tracks,imported_content,workshops,journeys',
            page: 1,
            per_page: 15,
            archived: '$ne,true',
            sort: 'createdAt,-1',
            published_only: true,
            manager_priority: true
          };

          self.information.searching = false;
          if (opts && typeof opts === 'object' && Object.keys(opts).length) {
            self.information.searching = true;
          }

          if (!self.information.searching) {
            self.information.activeContent = self.table.page_store[self.table.page];
            return;
          }
          self.information.loading = true;
          if (opts.term) {
            self.information.searchQuery['$or'] = '15,title,$regex,2,' + opts.term + ',i,tags,$regex,2,' + opts.term + ',i,name,$regex,2,' + opts.term + ',i';
          }

          if (opts.content) {
            self.information.searchQuery._id = opts.content;
          }

          AdminContent.findAnalytics(self.information.searchQuery).$promise.then(function(results) {
            self.information.loading = false;
            self.information.activeContent = results.data || [];
          }).catch(function (error) {
            self.information.loading = false;
            console.log('Error getting content:', error);
          });
        },
        start: function() {
          $scope.content.splice(0);
          for (var i = 0; i < self.information.simple_selection.length; i++) {
            $scope.content.push(self.information.directory[self.information.simple_selection[i]]);
          }
          self.information.showAssignment = true;
        },
        select: function(item) {
          var id = item._id;
          var index = self.information.simple_selection.indexOf(id);
          if (index === -1) {
            self.information.simple_selection.push(id);
            self.information.directory[id] = item;
            self.information.directory[id].type = self.information.directory[id].type ? self.information.directory[id].type : self.information.directory[id].name ? 'track' : 'article';
            $scope.content.push(item);
            return;
          }
          for (var i = 0; i < $scope.content.length; i++) {
            if ($scope.content[i]._id && $scope.content[i]._id.toString() === item._id.toString()) {
              $scope.content.splice(i, 1);
              break;
            }
          }
          self.information.simple_selection.splice(index, 1);
          delete self.information.directory[id];
        },
        removeSelections: function() {
          for (var i = self.information.simple_selection.length - 1; i >= 0; i--) {
            self.information.select(self.information.directory[self.information.simple_selection[i]]);
          }
          $scope.content.splice(0);
        }
      };

      self.initialize = function() {
        self.table.next();
        // update selection information with provided content
        if ($scope.content && $scope.content.length) {
          self.information.simple_selection = $scope.content.map(function(item) {
            return item._id.toString();
          });

          AdminContent.findAnalytics({
            types: 'videos,files,articles,scorm,assessments,tracks,imported_content,workshops,journeys',
            page: 1,
            per_page: 15,
            archived: '$ne,true',
            sort: 'createdAt,-1',
            _id: '$in,' + self.information.simple_selection.length + ',' + self.information.simple_selection.join(','),
            manager_priority: true
          }).$promise.then(function(results) {
            results.data.forEach(function(content) {
              self.information.directory[content._id] = content;
            });
          }).catch(function (error) {
            self.information.loading = false;
            console.log('Error getting content:', error);
          });
        }
      };

      self.initialize();

    }],
    controllerAs: 'select'
  };
}]);